// for user ad

export const RESET_USER_ADDITIONAL_INFO = "reset_user_additional_info";
export const USER_ADDITIONAL_INFO = "user_additional_info";
export const USER_ADDITIONAL_INFO_SUCCESS = "user_additional_info_success";
export const USER_ADDITIONAL_INFO_FAILURE = "user_additional_info_failure";
